import { postData } from "../../services/api.service";

export const fetchVendorActionLogDetails = async (action, id = null) => {
    const vendorLogs = JSON.parse(localStorage.getItem('vendorLogs')); // Parse vendorLogs
    if (vendorLogs && vendorLogs.id) {
        const logsDetailsPayload = {
            vendorActionLogsId: vendorLogs.id,
            action: id ? `${action} - ${id}` : action,
            remark: '',
        };

        try {
            await postData(
                '/vendors/logs/createVendorActionLogsDetails',
                logsDetailsPayload
            );
        } catch (error) {
            console.error(
                `Error during createVendorActionLogsDetails API call for ${action}:`,
                error
            );
        }
    } else {
        console.warn(
            'vendorLogs or vendorActionLogsId not found in localStorage'
        );
    }
};